import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash/get';

import List from '@hydra/routes/crawler/components/List';
import IssueTypeLabel from '@hydra/routes/crawler/components/IssueTypeLabel';

import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import DCUrlLabel from '@hydra/routes/crawler/components/DCUrlLabel';
import { Grid } from '@material-ui/core';

export class H1IssueRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      issue,
      columnStyles,
      className: classNameProp
    } = this.props;
    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const url = new DCUrl(domain, issue.url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start' key={issue.__dataID__}>
        <Grid item {...columnStyles[0]}>
          <IssueTypeLabel severity={issue.severity} type={issue.type} amount={issue.h1s.length} />
        </Grid>
        <Grid item {...columnStyles[1]}>
          <List bullet={<span>-&nbsp;&nbsp;</span>} itemsVisible={2} style={parseSeverity(issue.severity)} items={issue.h1s} />
        </Grid>
        <Grid item {...columnStyles[2]}>
          <DCUrlLabel url={url} severity={issue.severity} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(H1IssueRow, {
  issue: graphql`
    fragment H1IssueRow_issue on H1Issue {
      id
      type
      severity
      h1s
      url
    }
  `
});
